if (!customElements.get('mobile-bottom-nav')) {
  class MobileBottomNav extends HTMLElement {
    constructor() {
      super();
      this.cartUpdateUnsubscriber = undefined;
    }

    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }
    }

    disconnectedCallback() {
      if (typeof this.cartUpdateUnsubscriber === 'function') {
        this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = undefined;
      }
    }

    onCartUpdate(event) {
      if (event && event.cart && typeof event.cart.item_count !== 'undefined') {
        this.updateCartCount(event.cart.item_count);
        return;
      }

      const cartUrl = typeof routes !== 'undefined' && routes.cart_url ? `${routes.cart_url}.js` : '/cart.js';
      fetch(cartUrl)
        .then((response) => {
          if (!response.ok) throw new Error('Cart fetch failed');
          return response.json();
        })
        .then((cart) => {
          this.updateCartCount(cart.item_count);
        })
        .catch((error) => {
          console.error('Error updating mobile bottom navigation cart count:', error);
        });
    }

    updateCartCount(count) {
      const badge = this.querySelector('.mobile-bottom-nav__cart-count');
      if (!badge) return;

      const numericCount = parseInt(count, 10) || 0;
      badge.setAttribute('data-cart-count', numericCount);

      if (numericCount > 0) {
        badge.textContent = numericCount < 100 ? numericCount : '99+';
        badge.classList.remove('hidden');
      } else {
        badge.textContent = '0';
        badge.classList.add('hidden');
      }
    }
  }

  customElements.define('mobile-bottom-nav', MobileBottomNav);
}
